import React from 'react';
import { Box, Divider, Flex, HStack, Spacer } from '@chakra-ui/react';

import HeaderMenu from './HeaderMenu';
import { getComponentStyles } from '../../config/theme';
import HeaderDesktopLogo1Svg from '../../assets/HeaderDesktopLogo1Svg';
import HeaderDesktopLogoIcon from '../../assets/HeaderDesktopLogoIcon';
import HeaderMobileLogoIcon from '../../assets/HeaderMobileLogoIcon';
import SecurityAdvisorLogoOnlyIcon from '../../assets/SecurityAdvisorLogoOnlyIcon';

const Header: React.FC<{ authorized: boolean; onLogout?: Function }> = ({
    authorized,
    onLogout,
}) => {
    const { main, divider } = getComponentStyles('Header');

    return (
        <Box id={'header'} {...main}>
            <HStack>
                <Flex direction={'row'} gap={2} display={{ base: 'none', md: 'flex' }}>
                    <HeaderDesktopLogoIcon mt={'4px'} />
                    <Divider {...divider} />
                    <HeaderDesktopLogo1Svg />
                </Flex>

                <Box display={{ base: 'flex', md: 'none' }} width={'200px'}>
                    <HeaderMobileLogoIcon mr={'10px'} mt={'4px'} />
                    <Divider {...divider} />
                    <SecurityAdvisorLogoOnlyIcon ml={'10px'} />
                </Box>

                <Spacer />
                {authorized && <HeaderMenu onLogout={onLogout} />}
            </HStack>
        </Box>
    );
};

export default Header;
